import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent, _ } from '@icc/shared/helpers';
import { Subscription } from 'rxjs';
import { AppConfigFactory, APP_CONFIG } from '@icc/shared';
import { GenProduct } from '@icc/shared/types';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ConfigurationsService } from '../configurations.service';

@Component({
  selector: 'icc-product-features',
  templateUrl: './product-features.component.html',
  styleUrls: ['./product-features.component.scss']
})
export class ProductFeaturesComponent extends PageComponent implements OnInit {
  public title = _('CONFIGURATOR|Cechy produktów');

  private subscriptions: Subscription[] = [];

  products!: Promise<GenProduct[]>;
  hiddenPrice = false;
  curLang = this.config()?.CurLang || 'en';
  constructor(
    @Inject(APP_CONFIG) public config: AppConfigFactory,
    private configurationsService: ConfigurationsService<'window' | 'door'>,
    private httpClient: HttpClient
  ) {
    super();
  }

  ngOnInit() {
    this.hiddenPrice = this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator;
    this.getAllFeatures();
  }

  getAllFeatures() {
    const details = this.configurationsService.createSimpleConfiguration(this.configurationsService.conf.Current);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = String(urlParams.get('key'));
    const confType = urlParams.get('type') || 'window';
    const confMarketId = urlParams.get('marketId') || urlParams.get('market_id') || '1';
    const confLang = urlParams.get('lang') || 'pl';
    const params: {
      type: string,
      marketId: string,
      lang: string
  } = {
      type: confType,
      marketId: confMarketId,
      lang: confLang
  };
    this.products = this.httpClient
        .post<{ products: GenProduct[]}>(
            (this.config().EnvConfig?.remoteHost || window.location.origin)
            + '/api/configurator/product_features',
            {
                configuration: details
            },
            {
                headers: new HttpHeaders({
                    key: myParam,
                }),
                params
            }
        )
        .pipe(map(data => {
            return data.products
        })).toPromise();
  }
}
